import { TranslationBaseCardMessages, BaseCardMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationBaseCardMessages = {
  [BaseCardMessages.statusProgrammedLabelText]: "Tiempo de entrega estimado",
  [BaseCardMessages.statusProgrammedPrefixText]: "para",
  [BaseCardMessages.statusPreparingLabelText]: "Esperando confirmación",
  [BaseCardMessages.statusInTransitLabelText]: "En camino",
  [BaseCardMessages.statusInTransitPrefixText]: "hace",
  [BaseCardMessages.statusInConstructionLabelText]: "En construcción",
  [BaseCardMessages.statusInConstructionPrefixText]: "hace",
  [BaseCardMessages.statusInConstructionDescriptionText]: "Hora de llegada",
  [BaseCardMessages.statusDischargingLabelText]: "Descargando",
  [BaseCardMessages.statusDischargingPrefixText]: "hace",
  [BaseCardMessages.statusDischargingDescriptionText]: "Inicio de descarga",
  [BaseCardMessages.statusDeliveredLabelText]: "Tiempo de entrega",
  [BaseCardMessages.statusDeliveredDescriptionText]: "Hora de conclusión",
  [BaseCardMessages.statusCanceledLabelText]: "Entrega cancelada",
  [BaseCardMessages.statusInvoiceIssuedLabelText]: "Factura emitida",
  [BaseCardMessages.statusInvoiceIssuedPrefixText]: "hace",
  [BaseCardMessages.volumeText]: "Volumen",
  [BaseCardMessages.volumeTotalText]: "Volumen contratado",
  [BaseCardMessages.volumeDeliveredText]: "Entregado",
  [BaseCardMessages.volumeRemainingText]: "Saldo",
  [BaseCardMessages.volumePriceText]: "Valor/m³",
  [BaseCardMessages.installmentNumberText]: "Parcela",
  [BaseCardMessages.installmentDueDateText]: "Vencimiento",
  [BaseCardMessages.installmentSettlementDateText]: "Pago",
  [BaseCardMessages.installmentNetValueText]: "Valor",
  [BaseCardMessages.travelEquipmentText]: "Equipo",
  [BaseCardMessages.travelPlateText]: "Placa",
  [BaseCardMessages.travelDriverText]: "Conductor",
  [BaseCardMessages.travelProgrammedText]: "Programado",
  [BaseCardMessages.travelDocumentNumberText]: "Remesa",
  [BaseCardMessages.travelLoadLabelText]: "Lacre",
  [BaseCardMessages.concreteRecipeText]: "Receta",
  [BaseCardMessages.contractLabelText]: "Contrato",
  [BaseCardMessages.contractDateText]: "Fecha",
  [BaseCardMessages.contractSellerText]: "Vendedor",
  [BaseCardMessages.invoiceContractLabelText]: "Contrato",
  [BaseCardMessages.invoiceContractDateText]: "Fecha",
  [BaseCardMessages.invoiceNumberText]: "Nº da factura",
  [BaseCardMessages.invoiceDocumentTypeText]: "NFSe",
  [BaseCardMessages.invoiceTotalValueText]: "Valor total",
  [BaseCardMessages.certificateContractText]: "Contrato",
  [BaseCardMessages.certificateConcretingDateText]: "Fecho da hormigonado",
  [BaseCardMessages.certificateDateText]: "Fecha del informe",
  [BaseCardMessages.clientDocumentText]: "Documento",
  [BaseCardMessages.clientCreditLimitText]: "Limite de crédito",
  [BaseCardMessages.clientCreditLimitAvailableText]: "Crédito disponible",
  [BaseCardMessages.clientPendencyText]: "El registro está pendiente para",
  [BaseCardMessages.permissionClientNameText]: "Cliente",
  [BaseCardMessages.permissionContractText]: "Contrato",
  [BaseCardMessages.permissionDataText]: "Fecha",
  [BaseCardMessages.concretingRequestConcretingConcreteBatchingPlantText]:
    "Planta de entrega",
  [BaseCardMessages.concretingRequestConcretingDateText]:
    "Fecha de hormigonado",
  [BaseCardMessages.concretingRequestConcretingTimeText]: "Hora",
  [BaseCardMessages.concretingRequestConcretingIntervalText]: "Intervalo",
  [BaseCardMessages.concretingRequestObservationText]: "Observación",
  [BaseCardMessages.concretingRequestRequesterText]: "Solicitante",
  [BaseCardMessages.concretingRequestRequesterPhoneNumberText]: "Número de teléfone del solicitante",
  [BaseCardMessages.concretingRequestConcreteRecipeRequestedQuantityText]:
    "Cantidad requerida",
  [BaseCardMessages.concretingRequestConcretingRecipeContractedQuantityText]:
    "Cantidad contratada",
  [BaseCardMessages.concretingRequestConcretingRecipeBalanceAvailableText]:
    "Saldo disponible",
  [BaseCardMessages.concretingRequestConcreteRecipeQuantityPerConcreteMixerText]:
    "Cantidad por hormigonera",
  [BaseCardMessages.concretingRequestConcreteRecipePieceToBeConcretedText]:
    "Parte a hormigonar",
  [BaseCardMessages.concretingRequestPumpDescriptionText]: "Bomba",
  [BaseCardMessages.concretingRequestNoPumpTypesAvailableText]:
    "Ningún tipo de bomba en el contrato. Usando opciones predeterminadas.",
  [BaseCardMessages.concretingRequestPipingDistanceText]: "Distancia de tubería (m)",
  [BaseCardMessages.concretingResumeCanceled]: "Cancelado",
  [BaseCardMessages.concretingResumeDelivered]: "Entregado",
  [BaseCardMessages.concretingResumeDischarging]: "Descarga",
  [BaseCardMessages.concretingResumeInConstruction]: "En el trabajo",
  [BaseCardMessages.concretingResumeInTransit]: "En camino",
  [BaseCardMessages.concretingResumeNFSE]: "Factura emitida",
  [BaseCardMessages.concretingResumePreparing]: "Esperando",
  [BaseCardMessages.concretingResumeProgrammed]: "Programado",
  [BaseCardMessages.mapTextAgo]: "hace ",
  [BaseCardMessages.mapTextLastUpdate]: "Última actualización ",
  [BaseCardMessages.mapTextNameLabel]: "Nombre",
  [BaseCardMessages.mapTextNoTravelInProgress]:
    "Ningún camión de esta programación está en camino, en la obra o descargando ahora. El mapa muestra los camiones solo durante el viaje.",
  [BaseCardMessages.mapTextNoVehiclePosition]: "La ubicación de los camiones en viaje no está disponible en este momento."

};
